
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/premium/article-v3/[slug]",
      function () {
        return require("private-next-pages/premium/article-v3/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/premium/article-v3/[slug]"])
      });
    }
  